<template>
  <generic-page
    :image="content.img.url"
    image-height="90vh"
  >
    <v-card class="ma-5 pa-3">
      <v-card-title class="px-0 pb-4 px-lg-2 px-xl-2 pt-1 pt-lg-3 pt-xl-3 primary--text">
        <h1>{{ content.title }}</h1>
      </v-card-title>
      <v-card-text class="px-0 px-lg-2 px-xl-2">
        <prismic-rich-text :field="content.body" />
      </v-card-text>
    </v-card>
  </generic-page>
</template>

<script>
import genericPage from '../components/genericPage'

export default {
  name: 'Puslapis',
  components: { genericPage },
  data () {
    return {
      content: {
        title: null,
        body: [],
        img: { url: ''}
      }
    }
  },
  watch: {
    $route () {
      this.getContent()
    }
  },
  created () {
    this.getContent()
  },
  methods: {
    track () {
      this.$ga.page(this.$router)
    },
    isMobile () {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    async getContent () {
      const { data } = await this.$prismic.client.getByUID('puslapiai', this.$route.path.substring(1))
      this.content = {
        ...this.content,
        title: data.pavadinimas[0].text,
        body: data.tekstas,
        img: this.isMobile() ? data.virsutinis_paveikslelis.mobile : data.virsutinis_paveikslelis
      }
    }
  }
}
</script>

<style lang="scss">

</style>
